/**
 * True in iPhone Safari and iPhone in-app browsers, but not when WhaleTail
 * runs as an installed home-screen app. In those browsers the browser's own
 * toolbar floats over the bottom of the page and intercepts taps there.
 * (iPad Safari keeps its toolbar at the top, so iPads are excluded.)
 */
export function isIphoneBrowser(
  userAgent: string = navigator.userAgent,
  standalone: boolean = isStandalone(),
): boolean {
  return /iPhone|iPod/.test(userAgent) && !standalone;
}

function isStandalone(): boolean {
  return (
    (typeof window.matchMedia === 'function' &&
      window.matchMedia('(display-mode: standalone)').matches) ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

/** Flags the document so CSS can lift the tab bar clear of that toolbar. */
export function markBrowserUi(root: HTMLElement = document.documentElement): void {
  if (isIphoneBrowser()) root.dataset.iosBrowser = '';
  else delete root.dataset.iosBrowser;
}
